<template>

    <div class="locale_list">

        <div v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang" class="locale_list_item">
            <div class="flag_container" @click="changeLocale(lang)" :class="{active: lang == $i18n.locale}">
                <img class="locale_flag" :src="flagPath(lang)" />
            </div>
        </div>

    </div>

</template>

<script>

export default {
    name: 'LocaleList',
    props: {},
    data(){
        return {
            langs: ['fr', 'en']
        }
    },
    methods: {
        flagPath(lang){
            return require("@/assets/flags/" + lang + ".png")
        },
        changeLocale(lang){
            this.$i18n.locale = lang
            this.$date.locale(lang)
            localStorage.setItem('locale', lang)
        }
    }
}
</script>

<style lang="scss" >
.locale_list{
    display: flex;
    .locale_list_item{
        cursor: pointer;
        margin-right: 22px;
    }
    .flag_container{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 3px;
        border: 3px solid $dark;
        border-radius: 100%;
        transition: .3s all ease-in-out;
        &.active{
            border-color: $info;

        }
        .locale_flag{
            width: 32px;
            margin-right: 0;
        }
    }
}


</style>